// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../components/Images/search_lens.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-checkbox {
    width: 14px;
    height: 14px;
}

.table-checkbox-list {
    width: 20px;
    height: 20px;
    top: 16px;
    left: 16px;
}

.table-column-heading {
    font-size: 16px;
    font-weight: 500;
    font-family: "Poppins";
    height: 60px;
}

.table-column-title {
    font-size: 14px;
    font-weight: 500;
    line-height: 22px;
    width: 100%;
    font-family: "Poppins" !important;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    vertical-align: middle;
    max-width: 250px;
}

.table-search {
    max-width: 270px;
    width: 100%;
    padding: 13px 15px 13px 42px;
    background-size: 22px;
    background-repeat: no-repeat;
    background-position: 11px 13px;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.table-page-count {
    width: 41px;
    height: 39px;
}

.table-right-border {
    border-right-width: 1px;
}

.fast-length {
    width: 60px;
    height: 39px;
}

.show-all {
    width: 55px;
    padding: 4px 0px 4px 10px;
    height: 39px;
}

.table-column-grid-image {
    height: 200px;
    object-fit: cover;
}

.list-view-action .editdropdown {
    display: block;
}

.list-view-action .editdropdown-menu {
    left: -99px;
    top: -54px;
}

select[name="view_type"] {
    height: 40px;
}

.list-view-action .editdropdown-menu.grid {
    left: -176px !important;
    top: -91px !important;
}`, "",{"version":3,"sources":["webpack://./src/Styles/adminTable.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,UAAU;AACd;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,iCAAiC;IACjC,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,4BAA4B;IAC5B,qBAAqB;IACrB,4BAA4B;IAC5B,8BAA8B;IAC9B,yDAA6D;AACjE;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,qBAAqB;AACzB","sourcesContent":[".table-checkbox {\n    width: 14px;\n    height: 14px;\n}\n\n.table-checkbox-list {\n    width: 20px;\n    height: 20px;\n    top: 16px;\n    left: 16px;\n}\n\n.table-column-heading {\n    font-size: 16px;\n    font-weight: 500;\n    font-family: \"Poppins\";\n    height: 60px;\n}\n\n.table-column-title {\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 22px;\n    width: 100%;\n    font-family: \"Poppins\" !important;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n    vertical-align: middle;\n    max-width: 250px;\n}\n\n.table-search {\n    max-width: 270px;\n    width: 100%;\n    padding: 13px 15px 13px 42px;\n    background-size: 22px;\n    background-repeat: no-repeat;\n    background-position: 11px 13px;\n    background-image: url(\"../components/Images/search_lens.png\");\n}\n\n.table-page-count {\n    width: 41px;\n    height: 39px;\n}\n\n.table-right-border {\n    border-right-width: 1px;\n}\n\n.fast-length {\n    width: 60px;\n    height: 39px;\n}\n\n.show-all {\n    width: 55px;\n    padding: 4px 0px 4px 10px;\n    height: 39px;\n}\n\n.table-column-grid-image {\n    height: 200px;\n    object-fit: cover;\n}\n\n.list-view-action .editdropdown {\n    display: block;\n}\n\n.list-view-action .editdropdown-menu {\n    left: -99px;\n    top: -54px;\n}\n\nselect[name=\"view_type\"] {\n    height: 40px;\n}\n\n.list-view-action .editdropdown-menu.grid {\n    left: -176px !important;\n    top: -91px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
